<ng-container *ngrxLet="hideWorkingCondition$ as hideWorkingCondition">
  <div class="mt-2 mb-3">
    <apm-section-title [removeBottomMargin]="true" [title]="sectionTitle()" icon="t_units">
      <apm-icon
        class="d-inline-block me-2"
        *ngIf="showActions() && subCategoryId()"
        size="md"
        [icon]="!hideWorkingCondition ? 'a_full_screen' : 'a_small_screen'"
        [isButton]="true"
        (iconClick)="toggleStudy()"
        matTooltip="{{ (!hideWorkingCondition ? '445075' : '445077') | apmTranslate }}"
      ></apm-icon>
      <apm-icon
        class="d-inline-block me-2"
        *ngIf="unitWithAccessories.length > 0"
        size="md"
        [isButton]="true"
        (iconClick)="openPerformanceAssignmentDialog()"
        matTooltip="{{ '445155' | apmTranslate }}"
        icon="aa_alert_filter"
      ></apm-icon>
      <apm-icon
        class="d-inline-block me-2"
        *ngIf="showActions() && subCategoryId()"
        size="md"
        [isButton]="true"
        [hasHoverIcon]="true"
        (iconClick)="exportTableCsv()"
        matTooltip="{{ '445154' | apmTranslate }}"
        icon="a_download"
      ></apm-icon>
      <apm-icon
        class="d-inline-block"
        *ngIf="showActions()"
        size="md"
        [isButton]="true"
        [hasHoverIcon]="true"
        (iconClick)="goToModelSearch()"
        matTooltip="{{ '445151' | apmTranslate }}"
        icon="a_add"
      ></apm-icon>
      @if (showActions() && selectedRows.length > 0) {
        <apm-icon
          class="d-inline-block ms-2"
          size="md"
          [isButton]="true"
          [hasHoverIcon]="true"
          (iconClick)="deleteUnits()"
          matTooltip="{{ '444841' | apmTranslate }}"
          icon="a_delete"
        ></apm-icon>
      }
      @if (isFromStudy && isInterimStudy()) {
        <apm-icon
          class="d-inline-block ms-2"
          size="md"
          [isButton]="true"
          [hasHoverIcon]="true"
          (iconClick)="addAllUnits()"
          matTooltip="{{ 444738 | apmTranslate }}"
          icon="a_multi_add"
        ></apm-icon>
      }
    </apm-section-title>
  </div>

  <div
    class="study-models-table compressed-table"
    [ngClass]="{ 'by-subcategory': !!subCategoryId() && !hideWorkingCondition }"
  >
    <apm-table
      #table
      [rowHeight]="40"
      [gridId]="uniqueGridId()"
      [rowData]="unitPerformanceRows()"
      [columnDefs]="columnsReady() ? columnDefs : []"
      [persistColumnState]="true"
      [suppressRowTransform]="true"
      [postSortRows]="postSortRowsByUnits"
      [getRowStyle]="getRowStyle"
      [animateRows]="false"
      [hideExportContextMenuOption]="true"
      (action)="onAction($event)"
      (selectionChanged)="setSelectedRow($event)"
      (filterReset)="onFiltersReset()"
      rowSelection="multiple"
    ></apm-table>
  </div>
</ng-container>
